import React, { useState } from "react";
import { Button, Form, Select } from "antd";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { convertParamsIdToNumber, onChangeProvince } from "../../../core/utils";
import RangePicker from "../../../components/RangePicker/RangePicker";
import { useHistory, useLocation } from "react-router-dom";
import { parse } from "query-string";
import { useSelector } from "react-redux";

const FilterCarsServiceReport = ({
  provinces,
  getCarsServiceReport,
  exportCarServicesReport,
  cities,
  setCities,
  categories,
  cars,
  users,
  form,
  search,
  setSearch,
  getUsers,
}) => {
  const { Option } = Select;
  const store = useSelector((state) => state.Store);
  const location = useLocation();
  const history = useHistory();
  const params = parse(location.search);
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Form
      form={form}
      name="carsServiceReportForm"
      initialValues={{
        province_id: convertParamsIdToNumber(params.province_id),
        city_id: convertParamsIdToNumber(params.city_id),
        operator_id: convertParamsIdToNumber(params.operator_id),
        user_id: convertParamsIdToNumber(params.user_id),
        product_category_id: convertParamsIdToNumber(
          params.product_category_id
        ),
        purchase_date: [
          params.purchase_start_date || null,
          params.purchase_end_date || null,
        ],
      }}
      onFinish={() => {
        getCarsServiceReport();
        setIsVisible(false);
      }}
      requiredMark={false}
      scrollToFirstError
    >
      <FilterLayout
        search={search}
        setSearch={setSearch}
        onSearch={getCarsServiceReport}
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        placeHolder={
          "Search with driver name, plate number, driver mobile number or product name"
        }
        reportFilter={exportCarServicesReport}
      >
        <FormWrapper>
          <Form.Item
            className="input-size sm:w-100"
            name="province_id"
            colon={false}
          >
            <Select
              className="border-black-8 input-size sm:w-100 mb-10 "
              onChange={(value) =>
                onChangeProvince(
                  value,
                  () => {
                    form.setFieldValue("province_id", value);
                    form.setFieldValue("city_id", null);
                    form.setFieldValue("operator_id", null);
                    getUsers(value, null);
                  },
                  setCities
                )
              }
            >
              <Option value={null} name="All Provinces">
                All Provinces
              </Option>
              {provinces.map((province) => {
                return (
                  <Option value={province.id} name={province.name}>
                    {province.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item name="city_id" className="input-size sm:w-100 ">
            <Select
              className="border-black-8 mb-10 "
              onChange={(value) => {
                form.setFieldValue("city_id", value);
                form.setFieldValue("operator_id", null);
                getUsers(form.getFieldValue("province_id"), value);
              }}
            >
              <Option value={null} name="All Cities">
                All Cities
              </Option>
              {cities.map((city) => {
                return (
                  <Option value={city.id} name={city.name}>
                    {city.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            name={"product_category_id"}
            className=" input-size sm:w-100"
          >
            <Select
              className="border-black-8 mb-10"
              onChange={(value) =>
                form.setFieldValue("product_category_id", value)
              }
            >
              <Option value={null} name="All Categories">
                All Categories
              </Option>
              {categories.map((category) => {
                return (
                  <Option value={category.id} name={category.name}>
                    {category.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            className="input-size sm:w-100"
            style={{ marginBottom: "16px" }}
            name="purchase_date"
            colon={false}
          >
            <RangePicker
              className=" border-black-8 "
              currentRange={
                params.purchase_start_date
                  ? [params.purchase_start_date, params.purchase_end_date]
                  : []
              }
              onGetRange={(value) => form.setFieldValue("purchase_date", value)}
            />
          </Form.Item>

          <Form.Item
            className="input-size sm:w-100"
            name="user_id"
            colon={false}
          >
            <Select className="border-black-8 input-size sm:w-100 mb-10 ">
              <Option value={null} name="All Cars">
                All Cars
              </Option>

              {cars?.map((item) => {
                return (
                  <Option value={item.id} name={item.car.name}>
                    {item.car.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          {store?.user?.user_type !== "company_employee" ? (
            <Form.Item className="input-size sm:w-100" name="operator_id">
              <Select className="border-black-8 sm:w-100 mb-10 ">
                <Option value={null} name="All Employees">
                  All Employees
                </Option>
                {users.map((user) => {
                  return (
                    <Option key={user?.user?.id} value={user?.user?.id}>
                      {user?.user?.fullname}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          ) : (
            <div />
          )}
          <Button
            className="button-red input-size sm:w-100 "
            onClick={() => {
              history.push(window.location.pathname);
              setSearch("");
              setIsVisible(false);
              setTimeout(() => {
                form.resetFields();
                form.submit();
              }, 100);
            }}
          >
            Reset Filters
          </Button>
          <Button
            className="button-secondary input-size sm:w-100 mb-10"
            style={{ alignSelf: "start" }}
            htmlType="submit"
          >
            Filter
          </Button>
        </FormWrapper>
      </FilterLayout>
    </Form>
  );
};

export default FilterCarsServiceReport;
